<template>
  <div class="lp-child-base basic-result" :style="styles">
    <block-title :target-info="targetInfo" :color-scheme="colorScheme" />
    <!-- <block-fortune-result :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" /> -->
    <block-fortune-result2 :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" />
    <!-- <block-sns-share :target-info="targetInfo" :color-scheme="colorScheme" :result-share-words="resultShareWords" :result-share-url="resultShareUrl" :lp-id="lpId"/> -->
    <!-- <block-sns-share :target-info="targetInfo" :color-scheme="colorScheme" :result-share-words="resultShareWords" :result-share-url="resultShareUrl" :lp-id="lpId"/> -->
    <!-- <block-mokuji :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" /> -->
    <!-- <block-lead-menu :target-info="targetInfo" :color-scheme="colorScheme" :subsc-url="subscUrl" :lp-id="lpId" @link="clickLink" /> -->
    <block-lead-menu2 :target-info="targetInfo" :color-scheme="colorScheme" :subsc-url="subscUrl" :lp-id="lpId" @link="clickLink" />
    <block-about-type :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" :lp-id="lpId" />
    <!-- <block-lead-subsc :target-info="targetInfo" :color-scheme="colorScheme" :subsc-url="subscUrl" /> -->
    <!-- <block-advice :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" /> -->
    <!-- <block-title2 :target-info="targetInfo" :color-scheme="colorScheme" /> -->
    <!-- <block-fortune-input :target-info="targetInfo" :color-scheme="colorScheme" :action="action" :method="method" :token="token" :lp-id="lpId" pageLabel="basicresult" /> -->
    <!-- <block-faq :color-scheme="colorScheme" :subsc-url="subscUrl" /> -->

    <!-- <div class="block-deluxe-banner">
      <img src="/static/img/toppage/lp/hokatotoAll2.png" alt="本格＆豪華占い" @click="onDeluxeBannerClick">
    </div> -->

    <!-- <block-example-fortune :color-scheme="colorScheme" :lp-id="lpId" :subsc-url="subscUrl" /> -->

    <!-- <block-about-fortune2 :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId" :subsc-url="subscUrl"/> -->
    <block-about-fortune3
      v-if="previewResultList.length"
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :lp-id="lpId"
      :preview-result-list="previewResultList"
      :subsc-url="subscUrl"
    />
    <block-member :gadata-info="gadataInfo" :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId" :subsc-url="subscUrl"/>
    <block-points :ga-target="gaTarget" :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId" :subsc-url="subscUrl"/>
    <block-other-contents :ga-target="gaTarget" :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId" :subsc-url="subscUrl"/>
    <block-special :ga-target="gaTarget" :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId" :subsc-url="subscUrl"/>


    <!-- <block-uranai-tv-desc
      v-if="previewResultList.length"
      :lp-id="lpId"
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :preview-result-list="previewResultList"
      :subsc-url="subscUrl"
    /> -->
    <!-- <block-uranai-tv-desc2
      :lp-id="lpId"
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :subsc-url="subscUrl"
    /> -->
    <!-- <block-uranai-tv-short
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :subsc-url="subscUrl"
      :lp-id="lpId"
      page="basicresult"
      :emphasis-color="'#c9454d'"
      :is-individualed="false"
    /> -->

    <!-- <block-menus
      :lp-id="lpId"
      v-if="menusList.length"
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :menu-list="menusList"
      :tab-list="menusTabList"
      :ga-event-categ="`LP${lpId}basicresult-paid-content-button`"
      page="basicresult"
    /> -->
    <!-- <line-campaign-message :target-info="targetInfo" :color-scheme="colorScheme"/> -->
    <!-- <block-banner
      v-if="showBanner"
      banner-pos="1"
      :ga-event-categ="`LP${lpId}basicresult-LINE-campaign-banner`"
      :lp-id="lpId"
      :campaign="bannerType"
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :has-caption="false"
    /> -->

  </div>
</template>

<script>
import BlockTitle from '@/utvStore/components/recommend/lp/blocks/BlockTitle'
//import BlockFortuneResult from './blocks/BlockFortuneResult'
import BlockFortuneResult2 from './blocks/BlockFortuneResult2'
import BlockSnsShare from '@/utvStore/components/recommend/lp/blocks/BlockSnsShare'
// import BlockMokuji from './blocks/BlockMokuji'
//import BlockLeadMenu from './blocks/BlockLeadMenu'
import BlockLeadMenu2 from './blocks/BlockLeadMenu2'
//import BlockMenus from '@/utvStore/components/recommend/lp/blocks/BlockMenus'
import BlockAboutType from './blocks/BlockAboutType'
import BlockLeadSubsc from '@/utvStore/components/recommend/lp/blocks/BlockLeadSubsc'
// import BlockAdvice from './blocks/BlockAdvice'
import BlockTitle2 from '@/utvStore/components/recommend/lp/blocks/BlockTitle2'
import BlockFortuneInput from './blocks/BlockFortuneInput'
import BlockFaq from '@/utvStore/components/recommend/lp/blocks/BlockFaq'
import BlockBanner from '@/utvStore/components/recommend/lp/blocks/BlockBanner'
import LineCampaignMessage from '@/utvStore/components/recommend/lp/partials/LineCampaignMessage'
import BlockUranaiTvShort from '@/utvStore/components/recommend/lp/blocks/BlockUranaiTvShort'
import BlockExampleFortune from './blocks/BlockExampleFortune'
import BlockUranaiTvDesc from './blocks/BlockUranaiTvDesc'
import BlockUranaiTvDesc2 from './blocks/BlockUranaiTvDesc2'
import BlockMember from './blocks/BlockMember'
import BlockOtherContents from './blocks/BlockOtherContents'
import BlockSpecial from './blocks/BlockSpecial'
import BlockPoints from './blocks/BlockPoints'
import BlockAboutFortune2 from './blocks/BlockAboutFortune2'
import BlockAboutFortune3 from './blocks/BlockAboutFortune3'

/*
表示データメモ
resultDataの中身を上から
※ image1,text1/text5/text6,text2,text3,text4
image1,text8
image2,text10
image3,text12
 */


export default {
  name: 'BasicResult',
  components: {
    BlockMember,
    BlockOtherContents,
    BlockSpecial,
    BlockPoints,
    //BlockAboutFortune,
    BlockAboutFortune2,
    BlockAboutFortune3,
    BlockTitle,
    //BlockFortuneResult,
    BlockFortuneResult2,
    BlockSnsShare,
    // BlockMokuji,
    //BlockLeadMenu,
    BlockLeadMenu2,
    //BlockMenus,
    BlockAboutType,
    BlockLeadSubsc,
    // BlockAdvice,
    BlockTitle2,
    BlockFortuneInput,
    BlockFaq,
    BlockBanner,
    LineCampaignMessage,
    BlockUranaiTvShort,
    BlockExampleFortune,
    BlockUranaiTvDesc2,
    BlockUranaiTvDesc,

  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    menusList: {
      type: Array,
      default(){
        return []
      }
    },
    menusTabList: {
      type: Array,
      default(){
        return []
      }
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    resultData: Object,
    token: {
      type: String,
      default: '',
    },
    subscUrl: String,
    resultShareWords: {
      type: String,
      default: '',
    },
    bannerType: {
      type: String,
      default: 'LINE',
    },
    previewResultList: {
      type: Array,
      default() { return [] },
    },
    gadataInfo: {
      type: String,
      default: 'gaDataResult',
    },
    gaTarget: {
      type: String,
      default: 'basicresult',
    },

  },
  data(){
    return {
      action: `/recommend/lp/${this.lpId}/basic/action`,
      method: 'post'
    }
  },
  computed:{
    resultShareUrl(){
      return !!location.href ? location.href : ''
    },
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
        '--mess-bg': this.colorScheme.messBg,
      }
    },
    showBanner() {
      return true
    },
  },
  mounted() {
    console.log('resultData:%O', this.resultData)
  },
  methods: {
    clickLink (payload) {
      // console.log('clickLink:', payload)
      window.gtag('event', 'click', payload.param)
      let href = payload.link
      if (href === 'subsc') { href = this.subscUrl }
      if (href) { location.href = this.$handoverParams(href) }
    },
    onDeluxeBannerClick(){
      window.gtag('event', 'click', {
        'event_category': 'LP3basicresult-deluxe-menu',
        'event_label': '10001'
      })
      location.href = this.$handoverParams('/deluxe/lp/1')
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_col_mess_bg: var(--mess-bg);

ul {
    margin: 0;
    padding: 0;
    list-style: none;
}
.btn-base {
  width: 100%;
  padding: 20px;
}
.lp-child-base {
  color: #32373F;
  .block-title,
  .block-fortune-result,
  .block-about-type,
  .block-about-zokusei {
    background: #F9F5ED;
  }
  .block-title2,
  .block-fortune-input {
    background: #F2F2F2;
  }
  .block-menu-base--result,
  .line-campaign-message,
  .block-banner {
    background: #fff;
  }
  .block-sns-share {
    background: #fff;
    padding: 4px 0 25px;
  }
  .block-menu-base {
    padding-bottom: 22px;
    background: $l_col_mess_bg;
  }
  .block-deluxe-banner {
    width: 100%;
    padding: 40px 20px 10px;
    background: white;
    max-width: 580px;
    margin: auto;
    img {
      display: block;
      width: 100%;
      cursor: pointer;
      user-select: none;
    }
  }
  .block-banner {
    padding: 40px 20px 20px;
    // margin-bottom: 48px;
    // background: $l_col_mess_bg;
  }




  /deep/ {
    .block-lead-menu{
      background:#f9f5ed;
    }
    .block-lead-menu__comment {
      background: #fff;
      //font-weight: normal;
      &::after {
        border-right-color: #fff;
      }
      b{
        font-weight: normal;
      }
    }
    .block-about-type__title h2{
    font-weight: normal;
    font-size: 18px;
    }
  }
  .block-special-base {
    background: #fff;
    padding: 40px 0 0px;
  }
  /deep/ .block-uranaitv-base{
    background: #f2f2f2;
  }
  /deep/ .block-uranaitv-base__menu {
    background: #f9f5ed;
  }

  .block-sns-share {
    background: #f0ebe0;
    padding: 0px 0 25px;
  }

}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/touwa/BasicResult.vue